import { ChangeDetectorRef, Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSelectComponent } from '@shared/component/form-controls/select/abstract-select/abstract-select.component';
import { BankAccount, BankAccountService, BankAccountTypeEnum } from 'taxtank-core';
import { NgControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs';
import { BankConnectionsAddDialogComponent } from '@client/bank-feeds/components/bank-connections/bank-connections-add-dialog/bank-connections-add-dialog.component';

@Component({
  selector: 'app-bank-account-select',
  templateUrl: './bank-account-select.component.html',
  styleUrls: ['./bank-account-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BankAccountSelectComponent extends AbstractSelectComponent<BankAccount> {
  protected dialog = inject(MatDialog);
  private bankAccountService = inject(BankAccountService);

  @Input() emptyMessage = 'Please, add bank account';
  @Input() emptyOptionLabel = 'All bank accounts';
  @Input() placeholder = 'Select bank account';
  @Input() label = 'Bank account';
  @Input() canAdd = true;
  @Input() set types(value: BankAccountTypeEnum[]) {
    this.types$.next(value);
  }
  private readonly types$ = new BehaviorSubject<BankAccountTypeEnum[]>([]);

  dialogComponent = BankConnectionsAddDialogComponent;

  getOptions$(): Observable<BankAccount[]> {
    return combineLatest([this.bankAccountService.getActive(), this.types$]).pipe(
      map(([bankAccounts, types]) => {
        const filtered = types.length ? bankAccounts.filterBy('type', types) : bankAccounts;

        return filtered.getOwn().toArray();
      })
    );
  }
}
